// dadosDeCobranca.vm.js — CONTRATO da modal "Dados para o pagamento" (compra de pacote e de domínio).
// @version 1 (10/10/2026) — substitui o PackCpfDialog (pacote) e o CpfDialog do DomainsView (domínio):
//   CPF OU CNPJ (inclusive o CNPJ alfanumérico) + nome ou razão social. Plano:
//   docs/PLANO-DOCUMENTO-CPF-CNPJ-E-COBRANCA.md (TODO 3.3).
//
// A modal abre SEMPRE ao comprar, já preenchida com a cobrança salva (senão os dados da conta,
// senão em branco). Quem busca, mascara e valida é o hook useDadosDeCobranca — a View só exibe:
// `document` chega MASCARADO, erros chegam prontos. A View não valida nada.

/**
 * @typedef {Object} DadosDeCobrancaVM
 * @property {boolean} open
 * @property {boolean} loading          // buscando os dados salvos (campos desabilitados)
 * @property {boolean} busy             // gerando o pagamento (botões desabilitados, spinner no confirmar)
 * @property {string} title             // "Dados para o pagamento"
 * @property {string} explanation       // por que pedimos e onde muda depois
 * @property {string} name              // campo "Nome ou razão social"
 * @property {string|null} nameError
 * @property {string} document          // campo "CPF ou CNPJ", JÁ mascarado ("12.ABC.345/01DE-35")
 * @property {string|null} documentError
 * @property {string|null} formError    // erro devolvido pela API (fica na modal, o cliente corrige ali)
 * @property {string} confirmLabel      // "Gerar QR Code"
 */

/**
 * @typedef {Object} DadosDeCobrancaActions
 * @property {(value: string) => void} onChangeName
 * @property {(value: string) => void} onChangeDocument   // o hook remascara a cada tecla
 * @property {() => void} onConfirm
 * @property {() => void} onCancel                         // ignorado enquanto busy
 */

/** @typedef {{ vm: DadosDeCobrancaVM, actions: DadosDeCobrancaActions }} DadosDeCobrancaDialogProps */

export const DADOS_DE_COBRANCA_VM_VERSION = 1;

/**
 * Estado FECHADO, com todas as chaves do contrato. Fonte única para o hook (useDadosDeCobranca),
 * para quem embute a modal no próprio VM (domínio) e para os mocks — três cópias divergiriam.
 * @type {DadosDeCobrancaVM}
 */
export const DADOS_DE_COBRANCA_FECHADO = Object.freeze({
  open: false,
  loading: false,
  busy: false,
  title: 'Dados para o pagamento',
  explanation: 'Vão no comprovante do PIX. Ficam salvos para as próximas compras — dá para mudar em Configurações.',
  name: '',
  nameError: null,
  document: '',
  documentError: null,
  formError: null,
  confirmLabel: 'Gerar QR Code',
});
